module.exports = __webpack_public_path__ + "media/media/distributors/person-6-8c728078794e91e101381818f5839b76.jpg";